
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","fill":"#ff0","d":"M1-.3L-.7.8 0-1 .6.8-1-.3z"}})]),_c('path',{attrs:{"fill":"#ee1c25","d":"M0 0h512v512H0z"}}),_c('use',{attrs:{"xlink:href":"#a","width":"30","height":"20","transform":"matrix(76.8 0 0 76.8 128 128)"}}),_c('use',{attrs:{"xlink:href":"#a","width":"30","height":"20","transform":"rotate(-121 142.6 -47) scale(25.5827)"}}),_c('use',{attrs:{"xlink:href":"#a","width":"30","height":"20","transform":"rotate(-98.1 198 -82) scale(25.6)"}}),_c('use',{attrs:{"xlink:href":"#a","width":"30","height":"20","transform":"rotate(-74 272.4 -114) scale(25.6137)"}}),_c('use',{attrs:{"xlink:href":"#a","width":"30","height":"20","transform":"matrix(16 -19.968 19.968 16 256 230.4)"}})])
          )
        }
      }
    